$(document).ready(function() {
    // If we have a hash when loading.
    var target = document.getElementById(window.location.hash.substring(1));
    if (target !== null) {
        $('html, body').stop().animate({ 'scrollTop': $(target).offset().top - 88 }, 750, 'swing');
    }

    // Clicking on link with hash.
    $('a[href*=\\#]').on('click', function(e) {
        e.preventDefault();

        $('html, body').animate({ scrollTop:$(this.hash).offset().top - 88 }, 750, 'swing');
    });

    // Single page navigation - active highlighting on scrolling.
    var sections = document.querySelectorAll('.sp\\:grow.sp-single-page > div[id]');
    if (sections.length > 0) {
        var visible = new Set();

        // The highlighted link is the topmost section that is still below the sticky header (88px, plus one).
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    visible.add(entry.target);
                } else {
                    visible.delete(entry.target);
                }
            });

            var active = Array.prototype.find.call(sections, function (section) {
                return visible.has(section);
            });
            if (active === undefined) {
                return;
            }

            $('.sp-sidebar.sp-single-page .sp-active').removeClass('sp-active');
            $('.sp-sidebar.sp-single-page li a[href="#' + active.id + '"]').addClass('sp-active');
        }, { rootMargin: '-89px 0px 0px 0px' });

        sections.forEach(function (section) {
            observer.observe(section);
        });
    }
});

